import {
  useHelpCenterAlternateLink,
  useHelpCenterCanonicalUrl,
} from '@aboutyou/legacy-desktop/src/app/pages/HelpCenter/seo';
import {useUrlManagerStore} from '@aboutyou/legacy-desktop/src/app/store/context';
import {createHelpCenterSectionUrl} from '@aboutyou/legacy-shared/src/pages/HelpCenter/routes';
import {HelpCenterSection} from '@aboutyou/legacy-shared/src/pages/HelpCenter/types';

export const useGetCannonicalAndAlternateLink = (
  section: HelpCenterSection,
) => {
  const baseDomain = useUrlManagerStore(store => store.domain);

  const fallback = useHelpCenterCanonicalUrl();
  const sectionUrl = createHelpCenterSectionUrl(section);
  const canonicalUrl = !section ? fallback : `${baseDomain}${sectionUrl}`;
  const alternateLink = useHelpCenterAlternateLink(canonicalUrl);

  return {
    canonicalUrl,
    alternateLink,
  };
};
